import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api, { Project, ReleaseChannel, SortOrder, UploadProjectBuildCommand, UserProductStatus, UpdateProjectStoreDetailsCommand } from 'api';

export const getStripeAccountLink = createAsyncThunk(
  'finance/getStripeAccountLink',
  async (projectId: number) => {
    return api.getStripeAccountLink(projectId, window.location.href);
  },
);

export const getStripeAccount = createAsyncThunk(
  'finance/getStripeAccount',
  async (projectId: number) => {
    return api.getStripeAccount(projectId, window.location.href);
  },
);


const financeSlice = createSlice({
  name: 'finance',
  initialState: {},
  reducers: {},
  extraReducers: {},

});

const { reducer } = financeSlice;

export default reducer;
